const loader = (state=false,action) =>{
    if(action.type === "SET_LOADER"){
        state = action.payload
    }
    return state
}
export default loader;